import type { FaireProductEntity } from "../../entity_types/product";

export const faire_nudge_2: FaireProductEntity = {
  token: "faire_nudge_2",
  type: "product",
  name: "Lavender Candle",
  brandName: "Candle Brand",
  imageUrl:
    "https://images.unsplash.com/photo-1603006905003-be475563bc59?w=100&h=100&fit=crop",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
